import * as React from 'react';
import './CodeBlock.scss';

export const CodeBlock = ({ children }: { children: React.ReactChild }) => {
  return (
    <div className="component-code-block">
      <code>{children}</code>
    </div>
  );
};

export default CodeBlock;
